import { useCallback, useState, useEffect, PointerEvent, FormEvent, Fragment, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AutoSuggest, getSuggestAlias } from '@components/form/AutoSuggest';
import { Keyword } from '@components/form/Keyword';
import { LiveKeyword } from '@components/form/LiveKeyword';
import { selectAlias, selectL10N } from '@features/ui/UiSlice';
import { useAppDispatch, useAppSelector } from '@hooks/defineRtkTypedHook';
import { useOption } from '@hooks/useOption';
import { SEARCH_PARAMS } from '@constants/router';
import { setKeyword } from '../ui/UiSlice';

export const Form = () => {
    const l10n = useAppSelector(selectL10N);
    const option = useOption();
    const { useLiveKeyword, useAutoSuggest, serviceAlias } = option || {};
    const [searchParams, setSearchParams] = useSearchParams();
    const [inputValue, setInputValue] = useState(searchParams.get(SEARCH_PARAMS.KEYWORD) || '');
    const [isSubmit, setIsSubmit] = useState(false);

    const alias = useAppSelector(selectAlias);
    const suggestAlias = useMemo(() => getSuggestAlias(serviceAlias, alias, searchParams), [serviceAlias, alias, searchParams]);

    const dispatch = useAppDispatch();

    useEffect(() => {
        if(!isSubmit) {
            return;
        }
        
        if(inputValue && inputValue !== searchParams?.get(SEARCH_PARAMS.KEYWORD)) {
            //searchParams.set(SEARCH_PARAMS.KEYWORD, inputValue);
            //setSearchParams(searchParams);
            dispatch(setKeyword(inputValue));
            setIsSubmit(false);
            return;
        }

        setIsSubmit(false);
    }, [isSubmit, searchParams]);

    const submitCommon = useCallback((value: string) => {
        setInputValue(value);
        !isSubmit && setIsSubmit(true);
    }, [isSubmit]);

    const submitCallback = useCallback((e: PointerEvent<HTMLButtonElement | HTMLAnchorElement> | FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        submitCommon(inputValue);
    }, [inputValue, isSubmit]);

    // AutoSuggest의 옵션으로 콜백 전달 시, 콜백 내부의 state는 업데이트 되지 않고, 상태값 변경만 가능하여 isSearchReady값과 inputValue만 변경함
    const autoSuggestCallback = useCallback((clickKeyword: string) => {
        submitCommon(clickKeyword);
    }, [isSubmit]);

    return <div id="wrapSearchHeader" className="wrap-search-header">
        <div className="wrap-section-top">
            <div className="wrap-section-searchform">
                <div className="section-searchform">
                    <form id="autoSuggest" method="get" action="" onSubmit={submitCallback}>
                        <Keyword {...{isSubmit, inputValue, setInputValue, l10nTemplate: l10n?.template!}}/>
                        { useAutoSuggest && suggestAlias ? <AutoSuggest serviceAlias={serviceAlias} suggestAlias={suggestAlias} submitCallback={autoSuggestCallback}/> : <Fragment /> }
                    </form>
                </div>
                { useLiveKeyword ? <LiveKeyword itemClickCallback={submitCommon}/> : <Fragment /> }
            </div>
        </div>
    </div>;
};